import { ITodoCount } from '../planner-interfaces';

interface TodosCountProps {
    count: ITodoCount;
}

const TodosCount = ({ count }: TodosCountProps) => {

    return (
        <span className="flex items-center text-sm font-normal mx-4">
            <span>{ count.rootTodosCount }</span>
            {
                (count.rootTodosCount !== count.totalTodosCount) &&
                <span className="ml-1">({ count.totalTodosCount })</span>
            }
        </span>
    )
};

export default TodosCount;